import {defineMessages} from 'react-intl';

const messages = defineMessages({
  'find-events': {
    id: 'Header.menu.find-events',
    defaultMessage: 'Find Events',
  },
  holiday: {
    id: 'Header.menu.holiday',
    defaultMessage: 'Holiday',
  },
  search: {
    id: 'Header.menu.search',
    defaultMessage: 'Search',
  },
  sports: {
    id: 'Header.menu.sports',
    defaultMessage: 'Sports',
  },
  concerts: {
    id: 'Header.menu.concerts',
    defaultMessage: 'Concerts',
  },
  comedy: {
    id: 'Header.menu.comedy',
    defaultMessage: 'Comedy',
  },
  theater: {
    id: 'Header.menu.theater',
    defaultMessage: 'Theater',
  },
  'theater-comedy': {
    id: 'Header.menu.theater-comedy',
    defaultMessage: 'Theater & Comedy',
  },
  vip: {
    id: 'Header.menu.vip',
    defaultMessage: 'VIP',
  },
  soccer: {
    id: 'Header.menu.soccer',
    defaultMessage: 'Soccer',
  },
  cities: {
    id: 'Header.menu.cities',
    defaultMessage: 'Top Cities',
  },
  nhl: {
    id: 'Header.menu.nhl',
    defaultMessage: 'NHL',
  },
  'sell-tickets': {
    id: 'Header.menu.sell-tickets',
    defaultMessage: 'Sell Tickets',
  },
  sell: {
    id: 'Header.menu.sell',
    defaultMessage: 'Sell tickets',
  },
  'my-tickets': {
    id: 'Header.menu.my-tickets',
    defaultMessage: 'My Tickets',
  },
  'my-account': {
    id: 'Header.menu.my-account',
    defaultMessage: 'My account',
  },
  orders: {
    id: 'Header.menu.orders',
    defaultMessage: 'Orders',
  },
  listings: {
    id: 'Header.menu.listings',
    defaultMessage: 'My Listings',
  },
  sales: {
    id: 'Header.menu.sales',
    defaultMessage: 'My Sales',
  },
  payments: {
    id: 'Header.menu.payments',
    defaultMessage: 'Payments',
  },
  profile: {
    id: 'Header.menu.profile',
    defaultMessage: 'Profile',
  },
  'sign-in': {
    id: 'Header.menu.sign-in',
    defaultMessage: 'Sign In',
  },
  'sign-in-bullet': {
    id: 'Header.menu.sign-in',
    defaultMessage: 'Sign In',
  },
  'activity-feed': {
    id: 'Header.menu.activity-feed',
    defaultMessage: 'Activity Feed',
  },
  friends: {
    id: 'Header.menu.friends',
    defaultMessage: 'Friends',
  },
  'my-profile': {
    id: 'Header.menu.my-profile',
    defaultMessage: 'Sign In',
  },
  'gift-codes': {
    id: 'Header.menu.gift-codes',
    defaultMessage: 'StubHub Wallet',
  },
  'promo-codes': {
    id: 'Header.menu.promo-codes',
    defaultMessage: 'Promo Codes',
  },
  'my-profile.signedin': {
    id: 'Header.menu.my-profile.signedin',
    defaultMessage: 'Profile',
  },
  'my-hub': {
    id: 'Header.menu.my-hub',
    defaultMessage: 'My Hub',
  },
  'my-rewards': {
    id: 'Header.menu.my-rewards',
    defaultMessage: 'StubHub Wallet',
  },
  settings: {
    id: 'Header.menu.settings',
    defaultMessage: 'Settings',
  },
  logout: {
    id: 'Header.menu.logout',
    defaultMessage: 'Sign Out',
  },
  'have-questions': {
    id: 'Header.menu.have-questions',
    defaultMessage: 'Have Questions?',
  },
  help: {
    id: 'Header.menu.help',
    defaultMessage: 'Help',
  },
  'help-topics': {
    id: 'Header.menu.help-topics',
    defaultMessage: 'Help Topics',
  },
  'help-center': {
    id: 'Header.menu.help-center',
    defaultMessage: 'Help Center',
  },
  support: {
    id: 'Header.menu.support',
    defaultMessage: 'Support',
  },
  'contact-us': {
    id: 'Header.menu.contact-us',
    defaultMessage: 'Contact Us',
  },
  notifications: {
    id: 'Header.menu.notifications',
    defaultMessage: 'Notifications',
  },
  menu: {
    id: 'Header.menu.menu',
    defaultMessage: 'Menu',
  },
  'menu-account': {
    id: 'Header.menu.menu-account',
    defaultMessage: 'Menu account',
  },
  'menu-category': {
    id: 'Header.menu.menu-category',
    defaultMessage: 'Menu category',
  },
  'menu-help': {
    id: 'Header.menu.menu-help',
    defaultMessage: 'Menu help',
  },
  'menu.toggle': {
    id: 'Header.menu.menu.toggle',
    defaultMessage: 'Close',
  },
  inbenta: {
    id: 'Header.menu.inbenta',
    defaultMessage: 'Chat',
  },
  webphone: {
    id: 'Header.menu.webphone',
    defaultMessage: 'Buy by phone',
  },
});

export default messages;
